import App from "./App.svelte";
import * as Sentry from "@sentry/browser";
import applyPolyfill from "./helpers/array.js";

if (document.location.hostname !== "localhost") {
	Sentry.init({
		dsn: "https://4a874838888b4a2faf2855b0240df5c5@o1233526.ingest.us.sentry.io/6382382"
	});
}

applyPolyfill();

const app = new App({
	target: document.body
});

export default app;
